import React from "react";
import AntdMentions, {MentionProps} from 'antd/lib/mentions';
import { withError} from '@fishx/tracker';

const { getMentions, Option } = AntdMentions;

interface FMProps extends MentionProps {
  // forwardedRef?: React.Ref<HTMLElement>;
  forwardedRef?: any;
}
interface FCFMProps extends React.FC<FMProps> {
  getMentions:  typeof AntdMentions.getMentions;
  Option:  typeof AntdMentions.Option;
}

const Mentions: FCFMProps = (props) => {
  const { children, forwardedRef, ...rest } = props;
  return (
    <AntdMentions ref={forwardedRef} {...rest}>
      {children}
    </AntdMentions>
  ); 
}
Mentions.Option = Option;
Mentions.getMentions = getMentions;
export default withError(Mentions, {forwardRef: true});





// WEBPACK FOOTER //
// ./src/components/mentions/index.tsx